import axios from 'axios';

const API = "";

const api = axios.create({
  baseURL: `${API}/api`,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Interceptor to add X-View-As header when viewing another user.
// Initial value is hydrated from sessionStorage (set by AuthContext) so
// that the impersonation persists across full-page reloads — otherwise
// any legacy `<a href>` link in the app would silently revert the user
// back to themselves.
let _viewAsId = (() => {
  try {
    const raw = window.sessionStorage.getItem('ihtp_viewing_user');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.ID_Cliente ? String(parsed.ID_Cliente) : null;
  } catch { return null; }
})();
export function setViewAsId(id) { _viewAsId = id ? String(id) : null; }

api.interceptors.request.use((config) => {
  if (_viewAsId) {
    config.headers['X-View-As'] = String(_viewAsId);
  }
  return config;
});

export default api;
